import { put, takeLatest, all, call, take } from "redux-saga/effects";
import {
  setLoading,
  removeLoading,
  parseJwt,
  getItemFromLocalStorage,
} from "../../utils";
import { get, del, put as putCall, post } from "../../api";
import {
  GET_SALON_DETAILS,
  GET_SALON_DETAILS_SUCCESS,
  DELETE_SERVICE,
  ACTIVATE_SALON,
  DEACTIVATE_SALON,
  SUBMIT_FEEDBACK,
  GET_ANALYTICS,
  GET_ANALYTICS_SUCCESS,
  ADD_USER_ADDRESS,
  GET_USER_ADDRESS,
  SET_USER_ADDRESS,
  DEACTIVATE_USER_ADDRESS,
  UPDATE_USER_ADDRESS,
  GET_SALON_USERS,
  SET_SALON_USERS,
} from "../constants";
import {
  GET_SALON_DETAILS as GET_SALON_DETAILS_API,
  DELETE_SERVICE as DELETE_SERVICE_API,
  ACTIVATE_DEACTIVATE_SALON as ACTIVATE_DEACTIVATE_SALON_API,
  SUBMIT_FEEDBACK as SUBMIT_FEEDBACK_API,
  ADD_USER_ADDRESS as ADD_USER_ADDRESS_API,
  DELETE_USER_ADDRESS as ADD_DELETE_USER_ADDRESS_API,
  GET_SALON_USERS as GET_SALON_USERS_API,
} from "../../api/endpoints";

function* getSalonDetails({ payload: { salonId } = {} }) {
  setLoading();
  const baseApi = `${GET_SALON_DETAILS_API}${salonId}`;
  const salonDetails = yield call(get, baseApi);
  removeLoading();
  yield put({ type: GET_SALON_DETAILS_SUCCESS, data: salonDetails.data.salon });
}

function* deleteSalonService({ payload: { serviceId, salonId } }) {
  setLoading();
  const baseApi = `${DELETE_SERVICE_API}/${serviceId}`;
  yield call(del, baseApi);
  const baseApiGet = `${GET_SALON_DETAILS_API}${salonId}`;
  const salonDetails = yield call(get, baseApiGet);
  removeLoading();
  yield put({ type: GET_SALON_DETAILS_SUCCESS, data: salonDetails.data.salon });
}

function* activateSalon() {
  setLoading();
  const { salon_id } = parseJwt();
  const baseApi = `${ACTIVATE_DEACTIVATE_SALON_API}${salon_id}/activate`;
  yield call(putCall, {
    endpoint: baseApi,
    params: {},
  });
  window.location.href = "/";
}

function* deActivateSalon() {
  setLoading();
  const { salon_id } = parseJwt();
  const baseApi = `${ACTIVATE_DEACTIVATE_SALON_API}${salon_id}/deactivate`;
  yield call(putCall, {
    endpoint: baseApi,
    params: {},
  });
  window.location.href = "/";
}

function* submitFeedback({ payload }) {
  setLoading();
  const baseApi = `${SUBMIT_FEEDBACK_API}`;
  yield call(post, {
    endpoint: baseApi,
    params: payload,
  });
  window.location.href = `/`;
}

function* getSalonAnalytics({ payload: { month, year } }) {
  setLoading();
  const { salon_id } = parseJwt();
  const baseApi = `${GET_SALON_DETAILS_API}/${salon_id}/analysis?month=${month}&year=${year}`;
  const salonDetails = yield call(get, baseApi);
  const analysis = salonDetails.data.analysis;
  yield put({ type: GET_ANALYTICS_SUCCESS, data: analysis });
  removeLoading();
}

function* addUserAddress({ payload }) {
  setLoading();
  const location = getItemFromLocalStorage("location");

  payload.latitude = location.latitude;
  payload.longitude = location.longitude;
  payload.country = "India";

  const baseApi = `${ADD_DELETE_USER_ADDRESS_API}`;
  yield call(post, {
    endpoint: baseApi,
    params: payload,
  });
  removeLoading();
  window.location.href = `/user-address-list`;
}

function* getUserAddress() {
  setLoading();
  const { user_id } = parseJwt();
  const baseApi = `${ADD_USER_ADDRESS_API}/${user_id}/addresses`;
  const { data } = yield call(get, baseApi);
  yield put({ type: SET_USER_ADDRESS, data });
  removeLoading();
}

function* deactivateUserAddress({ payload }) {
  setLoading();
  const baseApi = `${ADD_DELETE_USER_ADDRESS_API}/${payload}/deactivate`;
  yield call(putCall, {
    endpoint: baseApi,
    params: {},
  });
  removeLoading();
  window.location.href = `/user-address-list`;
}

function* updateUserAddress({ payload: { addressId, ...restProps } }) {
  setLoading();
  restProps.country = "India";

  const baseApi = `${ADD_DELETE_USER_ADDRESS_API}/${addressId}`;
  yield call(putCall, {
    endpoint: baseApi,
    params: restProps,
  });
  removeLoading();
  window.location.href = `/user-address-list`;
}

function* getSalonUsers({ payload: { salonId, searchTerm } }) {
  setLoading();
  const baseApi = `${GET_SALON_USERS_API}/${salonId}/users?search=${searchTerm}`;
  const {
    data: { users },
  } = yield call(get, baseApi);
  yield put({ type: SET_SALON_USERS, data: users });
  removeLoading();
}

function* actionWatcher() {
  yield takeLatest(DELETE_SERVICE, deleteSalonService);
  yield takeLatest(GET_SALON_DETAILS, getSalonDetails);
  yield takeLatest(ACTIVATE_SALON, activateSalon);
  yield takeLatest(DEACTIVATE_SALON, deActivateSalon);
  yield takeLatest(SUBMIT_FEEDBACK, submitFeedback);
  yield takeLatest(GET_ANALYTICS, getSalonAnalytics);
  yield takeLatest(ADD_USER_ADDRESS, addUserAddress);
  yield takeLatest(GET_USER_ADDRESS, getUserAddress);
  yield takeLatest(DEACTIVATE_USER_ADDRESS, deactivateUserAddress);
  yield takeLatest(UPDATE_USER_ADDRESS, updateUserAddress);
  yield takeLatest(GET_SALON_USERS, getSalonUsers);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
